import { useState } from 'react';
import styled from 'styled-components';
import { ProgressBar } from '../atoms/ProgressBar';
import { SubmitButton } from '../atoms/SubmitButton';
import { SingleChoiceCard } from './card/SingleChoiceCard';
import { SingleChoiceAnswer } from '../../apis';

type TypeNoticeFormProps = {
  formKey?: string,
  questions: Question[],
  submitHandler: (noticeResult: noticeResult) => Promise<void>,
};

type Answers = {
  [key: string]: string
};

const TypeNoticeForm = (props: TypeNoticeFormProps) => {

  const questionCount = props.questions.length;
  const preAnswer: Answers = {};

  props.questions.forEach((question) => {
    if (question.answer) {
      preAnswer[question.key] = question.answer;
    }
  });

  const [ answers, setAnswers ] = useState<Answers>(preAnswer);

  if (!props.formKey) return <div>Form key is missing!</div>
  

  const answeredCount = Object.keys(answers).filter(ansKey => (answers[ansKey] && answers[ansKey].trim() !== '')).length;

  return (
    <>
      {
        props.questions.map((question, idx) => {
          let res;
          switch (question.type.toLowerCase()) {
            case "singlechoice":
              const convertQuestion = {
                constraints: {
                  choices: question.choices ?? [],
                  componentType: "RadioResp",
                },
                answer: {
                  text: question.choices?.find(choice => choice.value === answers[question.key])?.text ?? "",
                  value: answers[question.key],
                },
                richText:  question.richText,
                richHelpText: "",
              }
              res = <>
                <SingleChoiceCard
                  question={convertQuestion}
                  index={question.seq}
                  answerQuestion={async (answer) => {
                    const singleChoiceAnswer = answer.answer as SingleChoiceAnswer;
                    const updatedAnswer = {
                      ...answers,
                      [question.key]: singleChoiceAnswer.value,
                    };
                    setAnswers(updatedAnswer);
                  }}
                  errorMsg={""}
                  answerable={true}
                />
              </>;
              break;
            default:
              res = <></>;
          }

          return <div key={`que-${props.formKey}-${idx}`}>
            {res}
          </div>
        })
      }
      <BottomDiv>
        <ProgressBarSubmitContainer>
          <ProgressBar overall={questionCount} now={answeredCount} />
          <SubmitButton
            disabled={questionCount !== answeredCount}
            submitHandler={() => {
              const noticeResult: noticeResult = {
                formKey: props.formKey,
                formContents: answers
              }
              props.submitHandler(noticeResult);
            }}
            submitting={false}
          >
            告知しました
          </SubmitButton>
        </ProgressBarSubmitContainer>
      </BottomDiv>
    </>
  );
}

const BottomDiv = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 0 5%;
`;

const ProgressBarSubmitContainer = styled.div`
  width: 100%;
  max-width: 337px;
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export default TypeNoticeForm;
